import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionEndedPage } from '@/features/auth/SubscriptionEndedPage';

export const Route = createFileRoute('/subscription-ended')({ component: SubscriptionEndedPage });
